import moment from 'moment'

const actualDateFormatted = () => {
    return moment().format('D-M-YYYY')
}

export const dateFormattedSlash = (createdAt) => {
    return moment(createdAt).format('D/M/YYYY')
}

export const dateFormattedSlashWithHours = (date) => {
    return moment(date).format('DD/MM/YYYY HH:mm')
}

export const validateFormattedDate = (date, format = 'D/M/YYYY') => {
    return moment(date, format).isValid()
}

export const convertDate = (date, format) => {
    return moment(date, format)
}

export const yesterday = () => {
    return moment().startOf('day').subtract(1, 'days')
}

export const tomorrow = () => {
    return moment().startOf('day').add(1, 'days')
}

export const today = () => {
    return moment().startOf('day')
}

export const thisMonth = () => {
    return moment().startOf('month')
}

export const lastMonth = () => {
    return moment().startOf('month').subtract(1, 'months')
}

export const nextMonth = () => {
    return moment().startOf('month').add(1, 'months')
}

export const isPast = (dateA, dateB) => {
    return moment(dateA).isBefore(dateB)
}

export const timeOrDate = (date) => {
    const d = moment(date)

    if (isPast(d, today())) {
        return d.format('DD/MM/YYYY')
    }

    return d.format('HH:mm')
}

export default actualDateFormatted
